import {
  ServiceError,
  ServiceErrorType,
  UserErrorResponse,
  UserResponseOptions,
} from '../../services/common/serviceError';

/** Result callback */
export type UserResponse = (response: UserErrorResponse) => void;
/** Callback function */
export type RequestUserResponse = (
  errorType: ServiceErrorType,
  options: UserResponseOptions,
  resultCallback: UserResponse
) => void;

export class ServiceErrorCallback implements ServiceError {
  private requestUserResponse: RequestUserResponse;

  constructor(requestUserResponse: RequestUserResponse) {
    this.requestUserResponse = requestUserResponse;
  }

  async notifyUser(errorType: ServiceErrorType, options: UserResponseOptions): Promise<UserErrorResponse> {
    return new Promise<UserErrorResponse>((resolve) => {
      this.requestUserResponse(errorType, options, (userResult) => {
        resolve(userResult);
      });
    });
  }
}
